module.exports = __webpack_public_path__ + "img/96.052af685.png";